module.exports = __webpack_public_path__ + "img/dash-mob.03c646e1.png";